import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
var Option = /*#__PURE__*/function (_React$Component) {
  _inherits(Option, _React$Component);
  var _super = _createSuper(Option);
  function Option() {
    var _this;
    _classCallCheck(this, Option);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.onClick = function (event) {
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
      var option = _this.props.option;
      _this.props.onOptionChanged(option);
    };
    return _this;
  }
  _createClass(Option, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        option = _this$props.option,
        isActive = _this$props.isActive,
        optionClass = _this$props.optionClass;
      var className = "option-item ".concat(optionClass || '', " ").concat(isActive ? 'active' : '');
      return /*#__PURE__*/React.createElement("span", {
        className: className,
        onClick: this.onClick
      }, option.iconClass && /*#__PURE__*/React.createElement("span", {
        className: "item-icon ".concat(option.iconClass)
      }), /*#__PURE__*/React.createElement("span", {
        className: "label"
      }, option.label));
    }
  }]);
  return Option;
}(React.Component);
export default Option;